/**
 * Tender amount keypad edits — phone Floor, plan/27.
 */

export type TenderKey =
  | "0"
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "9"
  | "."
  | "back"
  | "clear";

/**
 * Apply one keypad stroke to a tender field string.
 * Caps fractional digits at 2; ignores extra dots.
 */
export function applyTenderKey(amount: string, key: TenderKey): string {
  if (key === "clear") return "";
  if (key === "back") {
    return amount.length <= 1 ? "" : amount.slice(0, -1);
  }
  if (key === ".") {
    if (amount.includes(".")) return amount;
    return amount === "" ? "0." : `${amount}.`;
  }
  if (amount.includes(".")) {
    const frac = amount.split(".")[1] ?? "";
    if (frac.length >= 2) return amount;
  }
  if (amount === "0") return key;
  return `${amount}${key}`;
}
